export default __webpack_public_path__ + "static/media/heavy-rain.d2bb0305.gif";